import { render, staticRenderFns } from "./ceshi.vue?vue&type=template&id=846a4a70"
import script from "./ceshi.vue?vue&type=script&lang=js"
export * from "./ceshi.vue?vue&type=script&lang=js"
import style0 from "./ceshi.vue?vue&type=style&index=0&id=846a4a70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports